const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    questionApplicationContent: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: '35vh'
    },
    formControl: {
        margin: theme.spacing(0)
    },
    group: {
        margin: `${theme.spacing(1)}px 0`
    },
    headerImageWrapper: {
        position: 'relative',
        margin: -theme.spacing(1) * 2,
        marginBottom: theme.spacing(0),
        marginTop: theme.paper ? -theme.paper.paddingTop : -theme.spacing(1) * 3,
        [theme.breakpoints.up(600)]: {
            margin: -theme.spacing(1) * 4,
            marginTop: -theme.spacing(1) * 4,
            marginBottom: theme.spacing(1)
        }
    },
    headerImage: {
        maxWidth: '100%'
    },
    extraElementsLinkWrapper: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex'
    },
    extraElementsLink: {
        margin: 'auto',
        padding: '1px 6px',
        textTransform: 'none',
        color: 'white!important'
    },
    buttons: {
        marginTop: theme.spacing(2),
        marginBottom: 0,
        paddingBottom: '0!important'
    },
    button: {
        width: '100%',
        fontWeight: 500,
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        color: '#fff!important',
        boxShadow: theme.button ? theme.button.boxShadow : null,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius : 32
    },
    completedPageButton: {
        marginBottom: 90
    },
    [theme.breakpoints.down(600)]: {
        buttons: {
            padding: '4px!important'
        },
        button: {
            padding: '8px 24px!important'
        },
        completedPageButton: {
            marginBottom: 0
        }
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(0.75),
        marginBottom: theme.spacing(0.75),
        marginRight: -theme.spacing(1) * 0.5
    },
    radio: {
        minWidth: '110px'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        marginRight: theme.spacing(2),
        minWidth: '112px'
    },
    logoImg: {
        filter: 'grayscale(100%)',
        opacity: 0.5
    },
    questionWrapper: {
        marginBottom: theme.spacing(2),
        flexGrow: 1
    },
    imageWrapper: {
        width: '100%',
        textAlign: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    image: {
        maxWidth: '100%',
        height: 'auto'
    },
    dialog: {
        margin: '0 -24px!important'
    },
    questionContainer: {
        width: 'calc(100% + 16px)',
        margin: '-8px',
        [theme.breakpoints.down(600)]: {
            width: 'calc(100% + 8px)',
            margin: '-4px'
        }
    },
    footerProgressBar: {
        marginTop: 33,
        borderRadius: 0,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        height: '9px !important',
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);'
    },
    hideOnDesktop: {
        [theme.breakpoints.up(600)]: {
            display: 'none'
        }
    }
})

export { styles }
